import { render, staticRenderFns } from "./PxfModalContent.vue?vue&type=template&id=36374e6a&scoped=true&"
import script from "./PxfModalContent.vue?vue&type=script&lang=js&"
export * from "./PxfModalContent.vue?vue&type=script&lang=js&"
import style0 from "./PxfModalContent.vue?vue&type=style&index=0&id=36374e6a&lang=scss&scoped=true&"
import style1 from "./PxfModalContent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36374e6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36374e6a')) {
      api.createRecord('36374e6a', component.options)
    } else {
      api.reload('36374e6a', component.options)
    }
    module.hot.accept("./PxfModalContent.vue?vue&type=template&id=36374e6a&scoped=true&", function () {
      api.rerender('36374e6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/components/PxfModalContent.vue"
export default component.exports